import { getErrorCode, getCooldownTime } from '@/helpers/apiErrors';
import setCooldownTimer from '@/helpers/setCooldownTimer'

/**
 * Works for both registration and password reset requests.
 * @returns {boolean} whether the cooldown has been applied to us.
 */
export default function(err) {
  // TODO add password reset code cooldown error code when it is added on the back-end.
  if (['auth.registration.confirmation_cooldown'].includes(getErrorCode(err))) {
    this.error = 'Слишком много запросов. Подождите';
    this.spamTimeoutTimerId = setCooldownTimer(
      getCooldownTime(err),
      n => this.spamTimeout = n,
      this.spamTimeoutTimerId,
    );

    // We can proceed to the code stage even if we're not currently on it because:
    // 1. At least as of now the back-end can return this error only if all other checks (e.g. password strength,
    // whether the user already exists) have passed, so we can be sure that it won't return a different error when we
    // ask it to send a new code.
    // 2. The 'resend' button just runs the same function as the 'submit' button on the stage bofore the 'code stage.
    this.stage = 'code';

    return true;
  }

  return false;
}
